import { fetchJson } from "src/utils/apiUtils";
import {
  IRemyndManual,
  IRemyndManualBrief,
  IRemyndManualMatchingSearch,
  IRemyndManualPaginateReq,
  IRemyndManualSaveReqContainer,
  IRemyndManualSimple
} from "./types";

const endpoint = `master/remyndManual`;

export const list = async (search: IRemyndManualPaginateReq) => {
  return fetchJson<IResponse<IPaginateResponse<IRemyndManualBrief>>>(
    `${endpoint}/listPaginate`,
    {
      method: "POST",
      body: JSON.stringify({ ...search })
    }
  );
};

export const get = async (id: RemyndManualId) => {
  return fetchJson<IResponse<IRemyndManual>>(`${endpoint}/${id}`, {
    method: "GET"
  });
};

export const save = async (req: IRemyndManualSaveReqContainer) => {
  return fetchJson<IResponse<RemyndManualId>>(`${endpoint}/save`, {
    method: "POST",
    body: JSON.stringify({ ...req })
  });
};

export const update = async (
  id: RemyndManualId,
  req: IRemyndManualSaveReqContainer
) => {
  return fetchJson<IResponse<RemyndManualId>>(`${endpoint}/update/${id}`, {
    method: "POST",
    body: JSON.stringify({ ...req })
  });
};

export const deleteMultiple = async (req: ICommonIdsReq) => {
  return fetchJson<IResponse<null>>(`${endpoint}/delete`, {
    method: "DELETE",
    body: JSON.stringify({ ...req })
  });
};

export const listMatching = async (search: IRemyndManualMatchingSearch) => {
  return fetchJson<IResponse<IRemyndManualSimple[]>>(
    `${endpoint}/listMatching`,
    {
      method: "POST",
      body: JSON.stringify({ ...search })
    }
  );
};
